import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { AccordionEventHandler, AccordionEventContext } from './index';

type Props = {
  allowMultiple?: boolean;
  children: React.ReactNode;
  isAlwaysOpen?: boolean;
  className?: string;
};

export const Accordion = ({
  allowMultiple = true,
  children,
  isAlwaysOpen = false,
  className,
  ...props
}: Props) => {
  const eventHandler = useMemo(
    () => new AccordionEventHandler(allowMultiple, isAlwaysOpen),
    [allowMultiple, isAlwaysOpen]
  );

  // Open the first element on initial render
  useEffect(() => {
    eventHandler.checkOpen();
  }, [eventHandler, eventHandler.subscribers.length]);

  const combinedClassName = classNames('accordion-container', className);

  return (
    <AccordionEventContext.Provider value={eventHandler}>
      <div {...props} {...{ className: combinedClassName }}>
        {children}
      </div>
    </AccordionEventContext.Provider>
  );
};
